import { render } from "./TaxiSharing.vue?vue&type=template&id=8ccd4464&ts=true"
import script from "./TaxiSharing.vue?vue&type=script&lang=ts"
export * from "./TaxiSharing.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__